export const poeApiBaseUrl = /*isDev ? 'http://localhost:3000' : */ 'https://planners.maxroll.gg'
export const gggAuthUrl = 'https://www.pathofexile.com/oauth/authorize'

export type PoeCharacterHit = {
  id: string
  name: string
  realm: string
  class: string
  league: string
  level: number
  experience: number
}
